
/**
* @ngdoc filter
* @name sharebase.filter:sbBadgeCount
* @kind function
* 
* @description
*  Returns a number for a badge
*
* @param {number} count of items.
* 
*/
export function GetBadgeCountFilter() {	
	return function getBadgeCount(val, maxCount = 99) {
		let numVal = parseInt(val);
		if(isNaN(numVal)){return 0;}
		
		return numVal > maxCount ? `${maxCount}+` : numVal.toString();
	};

}


// WEBPACK FOOTER //
// ./src/sharebase/filters/badgeCount.ts